import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TenantProvider } from './contexts/TenantContext';
import ProtectedLayout from './components/Layout/ProtectedLayout';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import MyClasses from './pages/MyClasses';
import ClassDetails from './pages/ClassDetails';
import EnterScores from './pages/EnterScores';
import Attendance from './pages/Attendance';
import Reports from './pages/Reports';
import SuperadminLogin from './pages/SuperadminLogin';
import SuperadminLayout from './components/Layout/SuperadminLayout';
import SuperadminOverview from './pages/SuperadminOverview';
import SuperadminTenants from './pages/SuperadminTenants';
import SuperadminSettings from './pages/SuperadminSettings';
import ManageTeachers from './pages/ManageTeachers';
import ManageSubjects from './pages/ManageSubjects';
import ManageClasses from './pages/ManageClasses';
import Profile from './pages/Profile';

/**
 * Main React Application Route Manager
 */
function App() {
  return (
    <TenantProvider>
      <Router>
        <Routes>
          {/* Public Access Channels */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          {/* Superadmin System Management Channels */}
          <Route path="/superadmin/login" element={<SuperadminLogin />} />
          <Route element={<SuperadminLayout />}>
            <Route path="/superadmin/dashboard" element={<SuperadminOverview />} />
            <Route path="/superadmin/tenants" element={<SuperadminTenants />} />
            <Route path="/superadmin/settings" element={<SuperadminSettings />} />
          </Route>
          
          {/* Tenant-Isolated Guarded Channels */}
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/classes" element={<MyClasses />} />
            <Route path="/classes/:classId" element={<ClassDetails />} />
            <Route path="/classes/:classId/grade" element={<EnterScores />} />
            <Route path="/classes/:classId/attendance" element={<Attendance />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/teachers" element={<ManageTeachers />} />
            <Route path="/subjects" element={<ManageSubjects />} />
            <Route path="/manage-classes" element={<ManageClasses />} />
            <Route path="/profile" element={<Profile />} />
          </Route>
        </Routes>
      </Router>
    </TenantProvider>
  );
}

export default App;
